module.exports = __webpack_public_path__ + "img/vertical_3_3_0.e945feb6.png";